import './filter.scss';
import axios from 'axios';
import { createElementFromHTML, getFormData } from './../../utilities/js/helper';
import { ResizeHandler } from './../../utilities/js/resize-handler';

class Filter {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-filter',
            allowUpdateUri: true,
            filterAttr: 'filter',
            filterBarAttr: 'bar',
            filterBarScrollerAttr: 'bar-scroller',
            filterBarItemsAttr: 'bar-items',
            barItemAttr: 'bar-item',
            barButtonsAttr: 'bar-buttons',
            selectedAttr: 'selected',
            pillAttr: 'pill',
            resultsAttr: 'results',
            toggleAttr: 'toggle',
            groupsAttr: 'groups',
            groupToggleAttr: 'group-toggle',
            groupHandleAttr: 'group-handle',
            comboAttr: 'combo',
            closeAttr: 'close',
            removeAttr: 'remove'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$filter = $element;
        this.$filterToggle = this.$filter.querySelector('[' + this.settings.initAttr + '="' + this.settings.toggleAttr + '"]');
        this.$results = this.$filter.querySelector('[' + this.settings.initAttr + '="' + this.settings.resultsAttr + '"]');
        this.$filterBar = this.$filter.querySelector('[' + this.settings.initAttr + '="' + this.settings.filterBarAttr + '"]');
        this.$filterItems = this.$filter.querySelector('[' + this.settings.initAttr + '="' + this.settings.filterAttr + '"]');
        this.$filterSelected = this.$filter.querySelector('[' + this.settings.initAttr + '="' + this.settings.selectedAttr + '"]');
        this.$$filterCombos = this.$filter.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.comboAttr + '"]');
        this.filterUri = this.$filter.getAttribute('action');
        this.$siteHeader = document.querySelector('[data-siteheader="root"]');
        this.$loadingSpinner = createElementFromHTML(window.OPTIONS.loader);
        this.currentComboBoxOpened = null;

        this.allowUpdateUri = this.settings.allowUpdateUri;

        if (this.$filter.getAttribute('no-update-uri') !== null) {
            this.allowUpdateUri = false;
        }

        this.documentClickTimeout = null;
        this.filterOpen = false;

        this.resizeHandler = new ResizeHandler();
        this.resizeHandler.init();

        this.initialize();
    }

    initialize () {
        this.setEvents();

        // close current combo on initial deeplink call
        if (this.$filter.querySelector('[' + this.settings.initAttr + '="combo-toggle"]:checked')) {
            this.currentComboBoxOpened = this.$filter.querySelector('[' + this.settings.initAttr + '="combo-toggle"]:checked').value;
            this.closeCombo();
        }
    }

    setEvents () {
        if (this.$siteHeader) {
            if (this.$filterToggle) {
                this.$filterToggle.addEventListener('change', () => {
                    clearTimeout(this.documentClickTimeout);

                    if (this.$filterToggle.checked === true) {
                        this.$siteHeader.classList.add('siteheader--filter-open');

                        this.documentClickTimeout = window.setTimeout(() => {
                            this.filterOpen = true;
                        }, 500);
                    } else {
                        this.$siteHeader.classList.remove('siteheader--filter-open');
                        this.filterOpen = false;
                    }
                });
            }
        }

        this.initCloseBtn(this.$$filterCombos);
        this.initFilterPills(this.$filterSelected, this.$filterItems);

        this.$filterItems.addEventListener('change', (e) => {
            const $element = e.target;
            if ($element.getAttribute('formtrigger') === 'ignore') {
                e.preventDefault();
            } else {
                this.updateList();
            }

            if ($element.closest('[' + this.settings.initAttr + '="' + this.settings.groupToggleAttr + '"]')) {
                if ($element.checked === true) {
                    $element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            }

            // check if combo click
            if ($element.getAttribute(this.settings.initAttr) === 'combo-toggle') {
                if ($element.checked === true) {
                    if (this.currentComboBoxOpened !== null) {
                        this.closeCombo();
                    }
                    this.currentComboBoxOpened = $element.value;
                } else {
                    this.currentComboBoxOpened = null;
                }
            }
        });

        this.$filterItems.addEventListener('click', (e) => {
            const $element = e.target;

            if ($element.closest('[' + this.settings.initAttr + '="' + this.settings.closeAttr + '"]')) {
                this.$filterToggle.checked = false;

                const toggleUpdateEvent = new CustomEvent('change', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });
                this.$filterToggle.dispatchEvent(toggleUpdateEvent);

                e.preventDefault();
            }

            if ($element.closest('[' + this.settings.initAttr + '="' + this.settings.groupHandleAttr + '"]')) {
                const $target = document.getElementById($element.getAttribute('for'));
                if ($target.checked === true) {
                    $target.checked = false;
                } else {
                    $target.checked = true;
                }

                const targetUpdateEvent = new CustomEvent('change', {
                    view: window,
                    bubbles: true,
                    cancelable: false
                });

                $target.dispatchEvent(targetUpdateEvent);

                e.preventDefault();
            }
        });

        if (this.$filterBar) {
            this.$filterBar.addEventListener('click', (e) => {
                const $element = e.target;
                if ($element.closest('[' + this.settings.initAttr + '="' + this.settings.barItemAttr + '"]') !== null) {
                    if (this.$filterToggle.checked === false) {
                        this.$filterToggle.checked = true;

                        const toggleUpdateEvent = new CustomEvent('change', {
                            view: window,
                            bubbles: true,
                            cancelable: false
                        });
                        this.$filterToggle.dispatchEvent(toggleUpdateEvent);
                    }
                }

                if ($element.closest('[' + this.settings.initAttr + '="' + this.settings.removeAttr + '"]') !== null) {
                    const $currentFilter = this.$filterItems.querySelectorAll('input:checked:not([formtrigger="ignore"])');

                    for (let i = 0; i < $currentFilter.length; i++) {
                        $currentFilter[i].checked = false;

                        if (i === $currentFilter.length - 1) {
                            const filterUpdateEvent = new CustomEvent('change', {
                                view: window,
                                bubbles: true,
                                cancelable: false
                            });
                            this.$filterItems.dispatchEvent(filterUpdateEvent);
                        }
                    }
                }
            });
        }

        this.$filter.addEventListener('reset', (e) => {
            this.updateList(true);
            e.preventDefault();
        });

        document.addEventListener('click', (e) => {
            const $element = e.target;
            if (this.filterOpen === true) {
                if (!this.$filterItems.contains($element) && $element !== this.$filterItems) {
                    this.closeFilter();

                    e.preventDefault();
                }
            }

            if ($element.getAttribute(`${this.settings.initAttr}`) === 'value' && $element.getAttribute('rel') !== '') {
                const targetId = $element.getAttribute('rel');
                const $target = document.getElementById(targetId);
                if ($target) {
                    $target.removeAttribute('value');

                    const targetUpdateEvent = new CustomEvent('change', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });

                    $target.dispatchEvent(targetUpdateEvent);
                }
            }

            // check if click in opened combo box
            const $comboBox = $element.closest(`[${this.settings.initAttr}="${this.settings.comboAttr}"]`);
            if (!$comboBox && this.currentComboBoxOpened !== null) {
                this.closeCombo();
            }
        });
    }

    initCloseBtn ($$filterCombos) {
        if ($$filterCombos.length > 0) {
            $$filterCombos.forEach($filterCombo => {
                const $$closeCombo = $filterCombo.querySelectorAll('[data-filter-combo-close]');
                const $comboToggle = $filterCombo.querySelector('[data-filter="combo-toggle"]');
                const $filterScroller = this.$filter.querySelector('[data-filter="scroller"]');

                if ($comboToggle) {
                    $comboToggle.onchange = () => {
                        if ($filterScroller) {
                            $filterScroller.dataset.filterBarOpen = $comboToggle.checked;

                            const $comboContent = $filterCombo.parentElement.querySelector('[data-filter-combo="content"]');
                            const $comboDateRange = $filterCombo.parentElement.querySelector('[data-filter-daterange="content"]');

                            if ($comboToggle.checked && $comboContent) {
                                const $firstInput = $comboContent.querySelector('input');
                                if ($firstInput) {
                                    $firstInput.focus();
                                }
                            }

                            if ($comboToggle.checked && $comboDateRange) {
                                setTimeout(() => {
                                    const $datePickerContainer = $comboDateRange.querySelector('.easepick-wrapper');

                                    if ($datePickerContainer) {
                                        $datePickerContainer.setAttribute('tabindex', 0);
                                        $datePickerContainer.setAttribute('role', 'group');
                                        $datePickerContainer.setAttribute('aria-label', 'Kalender');
                                        $datePickerContainer.focus();
                                    }
                                }, 100);
                            }
                        }
                    };
                }

                if ($$closeCombo.length > 0) {
                    $$closeCombo.forEach($closeCombo => {
                        $closeCombo.onclick = (e) => {
                            e.preventDefault();

                            if ($comboToggle) {
                                $comboToggle.click();
                            }
                        };
                    });
                }
            });
        }
    }

    initFilterPills ($filterSelected, $filterItems) {
        const $$filterPills = $filterSelected.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.pillAttr + '"]');
        if ($$filterPills.length > 0) {
            $$filterPills.forEach($filterPill => {
                const deselectItem = () => {
                    const $filterItem = $filterItems.querySelector(`[data-filter-item-id="${$filterPill.dataset.filterSelectedId}"]`);
                    if ($filterItem) {
                        $filterItem.click();
                    }
                };

                $filterPill.onclick = () => {
                    deselectItem();
                };

                $filterPill.onkeydown = (e) => {
                    if (e.code === 'Space' || e.code === 'Enter') {
                        e.preventDefault();
                        deselectItem();
                    }
                };
            });
        }
    }

    closeCombo () {
        const $comboToggle = this.$filter.querySelector(`[${this.settings.initAttr}="combo-toggle"][value="${this.currentComboBoxOpened}"]`);
        $comboToggle.checked = false;
        this.currentComboBoxOpened = null;
    }

    closeFilter () {
        this.$filterToggle.checked = false;

        const toggleUpdateEvent = new CustomEvent('change', {
            view: window,
            bubbles: true,
            cancelable: false
        });
        this.$filterToggle.dispatchEvent(toggleUpdateEvent);
    }

    updateUri (formData) {
        if (this.allowUpdateUri === true) {
            let uri = this.filterUri;

            const serializedData = Array.from(
                formData,
                e => e.map(encodeURIComponent).join('=')
            ).join('&');

            if (serializedData) {
                if (uri.includes('?')) {
                    uri = uri + '&' + serializedData;
                } else {
                    uri = uri + '?' + serializedData;
                }
            }

            this.setHistory(uri);
        }
    }

    updateList (clean = false) {
        let formData = '';
        if (clean === false) {
            formData = getFormData(this.$filterItems);
        }

        this.updateUri(formData);

        if (this.$results) {
            this.$results.appendChild(this.$loadingSpinner.cloneNode(true));
        }

        axios({
            method: 'POST',
            url: this.filterUri,
            data: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((result) => {
                if (result && result.data) {
                    const $result = createElementFromHTML(result.data);

                    window.dispatchEvent(new CustomEvent('filter_bar.update_filter', {
                        view: window,
                        bubbles: true,
                        cancelable: false,
                        detail: {
                            $context: $result
                        }
                    }));

                    if (this.$filterItems) {
                        const $filterResult = $result.querySelector('[' + this.settings.initAttr + '="' + this.settings.filterAttr + '"]');
                        this.$filterItems.innerHTML = $filterResult.innerHTML;
                        const $$filterCombos = this.$filterItems.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.comboAttr + '"]');
                        const $nextTabElement = this.$filterItems.querySelector('input');

                        window.dispatchEvent(new CustomEvent('content.loaded', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: this.$filterItems
                            }
                        }));

                        this.initCloseBtn($$filterCombos);

                        if ($nextTabElement) {
                            $nextTabElement.focus();
                        }
                    }

                    if (this.$results) {
                        const $itemsResult = $result.querySelector('[' + this.settings.initAttr + '="' + this.settings.resultsAttr + '"]');
                        this.$results.innerHTML = $itemsResult.innerHTML;

                        window.dispatchEvent(new CustomEvent('content.loaded', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: this.$results
                            }
                        }));
                    }

                    if (this.$filterBar) {
                        const $filterBarResult = $result.querySelector('[' + this.settings.initAttr + '="' + this.settings.filterBarAttr + '"]');
                        this.$filterBar.innerHTML = $filterBarResult.innerHTML;

                        window.dispatchEvent(new CustomEvent('content.loaded', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: this.$filterBar
                            }
                        }));
                    }

                    if (this.$filterSelected) {
                        const $filterSelected = $result.querySelector('[' + this.settings.initAttr + '="' + this.settings.selectedAttr + '"]');
                        this.$filterSelected.innerHTML = $filterSelected.innerHTML;

                        window.dispatchEvent(new CustomEvent('content.loaded', {
                            view: window,
                            bubbles: true,
                            cancelable: false,
                            detail: {
                                $context: this.$filterSelected
                            }
                        }));
                    }

                    if (!this.$filterItems.querySelector('[' + this.settings.initAttr + '="combo-toggle"]:checked')) {
                        this.currentComboBoxOpened = null;
                    }

                    if (this.$filterSelected && this.$filterItems) {
                        this.initFilterPills(this.$filterSelected, this.$filterItems);
                    }
                }
            })
            .catch((error) => {
                throw Error(error);
            });
    }

    setHistory (uri) {
        history.pushState(null, document.title, uri);
    }
}

export { Filter };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$filter = $context.querySelectorAll('[data-filter="root"]:not([data-init="true"])');
        for (let i = 0; i < $$filter.length; i++) {
            const $filter = $$filter[i];

            const filterAPI = new Filter($filter);
            $filter.API = filterAPI;
            $filter.setAttribute('data-init', 'true');
        }
    }
});
